"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _columns = _interopRequireDefault(require("./columns"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconGroup = _ref => {
  let {
    obj
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex justify-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_columns.default, {
      col: 6,
      children: obj.map((itemm, index) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "iconGroupItem",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "icon",
            children: itemm.icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: itemm.icon_title
          })]
        }, index);
      })
    })
  });
};
var _default = IconGroup;
exports.default = _default;